import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-onboarding-errors-dialog',
    templateUrl: './onboarding-errors-dialog.component.html',
    styleUrls: ['./onboarding-errors-dialog.component.scss']
})
export class OnboardingErrorsDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: { errors: string[]; isSeller: boolean}) {
        console.log('isSeller', data.isSeller); 
     }
} 